import AllNotifications from '@/components/AllNotifications';
import UncheckedNotifications from '@/components/UncheckedNotifications';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { clearAllNotifications, clearUncheckedNotifications } from '@/store/pushNotification/action';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import React, { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
const Notification: React.FC = () => {
    const { strings, haveUnreadNotifications } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        haveUnreadNotifications: state.pushNotification.data.listUncheckedPushNotification.total > 0,
    }));

    const dispatch = useDispatch();

    const [active, setActive] = useState<boolean>(false);
    const [loadNotifications, setLoadNotifications] = useState<boolean>(true);

    const handleOnToogle = (isOpen: boolean) => {
        setActive(isOpen);
    };

    useEffect(() => {
        return () => {
            dispatch(clearUncheckedNotifications());
            dispatch(clearAllNotifications());
            setLoadNotifications(false);
        };
    }, [dispatch, strings._LANGUAGE]);

    useEffect(() => {
        if (!loadNotifications) {
            setLoadNotifications(true);
        }
    }, [loadNotifications]);

    return (
        <div className="notification-container">
            <Dropdown onToggle={handleOnToogle}>
                <Dropdown.Toggle id="btn-notifications" variant="link">
                    {haveUnreadNotifications && <div className="notification-alert"></div>}
                    <i className="material-icons-outlined">{Constants.icons.NOTIFICATIONS}</i>
                </Dropdown.Toggle>
                {loadNotifications && (
                    <Dropdown.Menu className="px-2 py-2" renderOnMount>
                        <div className="triangle-container">
                            <div className="dropdown-triangle" />
                            <div className="dropdown-triangle-border" />
                        </div>

                        <Tabs unmountOnExit>
                            <Tab eventKey="unread" title={strings.NOTIFICATION_UNREAD}>
                                <UncheckedNotifications active={active} />
                            </Tab>
                            <Tab eventKey="all" title={strings.NOTIFICATION_ALL}>
                                <AllNotifications active={active} />
                            </Tab>
                        </Tabs>
                    </Dropdown.Menu>
                )}
            </Dropdown>
        </div>
    );
};

export default Notification;
